/**
 * 参考文档：http://ask.dcloud.net.cn/article/431
 * 升级文件为JSON格式数据，如下：
 * 
 * 需升级
 {
	"version": "2.6.0",
	"title": "Hello MUI版本更新",
	"note": "修复“选项卡+下拉刷新”示例中，某个选项卡滚动到底时，会触发所有选项卡上拉加载事件的bug；\n修复Android4.4.4版本部分手机上，软键盘弹出时影响图片轮播组件，导致自动轮播停止的bug；",
	"url": "http://www.dcloud.io/hellomui/HelloMUI.apk"
}
*
 */
import axios from "axios";


function update() {
  const plus = window.plus
  const server = "http://airport.hsort.net/api/tophandler.ashx?method=Utils.SelectList.AppLogGet"; //获取升级描述文件服务器地址
  axios.get(server, {
    params: {
      "app_id": plus.runtime.appid,
      /*"version": plus.runtime.version,
      "imei": plus.device.imei*/
    }
  }).then((rsp) => {
    if (rsp.code !== 0) return;
    data = rsp.result;
    if (data != null) {
      var v1 = data.version.split(".");
      var v2 = plus.runtime.version.split(".");
      if (parseInt(v1[0]) > parseInt(v2[0]) ||
        (parseInt(v1[0]) == parseInt(v2[0]) && parseInt(v1[1]) > parseInt(v2[1])) ||
        (parseInt(v1[0]) == parseInt(v2[0]) && parseInt(v1[1]) == parseInt(v2[1]) && parseInt(v1[2]) > parseInt(v2[2]))) {
        plus.nativeUI.confirm(data.note, function (event) {
          if (0 == event.index) {
            plus.runtime.openURL(data.url);
          }
        }, data.title, ["立即更新", "取　　消"]);
      }
    }
  })
}

if (window.plus) {
  update();
} else {
  document.addEventListener("plusready", update, false);
}



// WEBPACK FOOTER //
// ./src/utils/update.js